import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const SaveAlert = async (alert,navigate) => {
  const accesstoken = getToken();

  if (accesstoken) {
    try {
        let Payload =
            {
                "alertID": alert.alertID,
                "jobsiteID": alert.jobsiteID,
                "alertDescription": alert.alertDescription,
                "isActive": alert.isActive
            }        
          
      const response = await fetch(`${dev_baseUrl}/Jobsite/saveAlert`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(Payload),
      });

      const data = await response.json();
      
    if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
    } else if(response.ok && !data.isError ){      
      return data;
    } 
    else {
      console.error('Server Error:',data.message);
      return data;
      }
    } catch (error) {
      console.error('Network error:', error);
      return { isError:true, message: 'An error occurred. Please try again later.' , error: error};
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};
